var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddTagsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#F0F1F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5382 10.4638L15.5345 10.4638M17.3866 7.66321L14.003 7.40294C13.7031 7.37987 13.408 7.48903 13.1952 7.70177L7.7003 13.1967C7.29782 13.5992 7.29782 14.2517 7.7003 14.6542L11.3441 18.298C11.7466 18.7005 12.3992 18.7005 12.8016 18.298L18.2966 12.8031C18.5093 12.5904 18.6185 12.2953 18.5954 11.9953L18.3351 8.61176C18.2961 8.10492 17.8934 7.7022 17.3866 7.66321Z",
    stroke: "#616874",
    strokeWidth: 1.63,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTagsIcon);
export default __webpack_public_path__ + "static/media/add-tags-icon.de3d8fd32fdf4d2c50e35688abb2cefe.svg";
export { ForwardRef as ReactComponent };